<script setup lang="ts">
import { ref } from 'vue'

// Estado para los toggles y selecciones
const showCode = ref(false)
const showSuggestions = ref(true)
const theme = ref('System')
const language = ref('Auto-detect')
</script>

<template>
  <div class="settings-container">
    <div class="settings-header">
      <h1 class="text-h4 font-weight-medium">Settings</h1>
      <v-btn icon class="close-button" @click="$emit('close')">
        <v-icon size="30">mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="settings-content">
      <!-- Sidebar navigation -->
      <div class="settings-sidebar">
        <v-list nav class="settings-list">
          <v-list-item prepend-icon="mdi-cog" title="General" class="settings-list-item active" />
          <v-list-item prepend-icon="mdi-bell-outline" title="Notificaciones" class="settings-list-item" />
          <v-list-item prepend-icon="mdi-account-cog-outline" title="Personalizacion" class="settings-list-item" />
          
          <v-list-item prepend-icon="mdi-database-cog-outline" title="Control datos" class="settings-list-item" />
          <v-list-item prepend-icon="mdi-file-document-outline" title="Data" class="settings-list-item" />
          <v-list-item prepend-icon="mdi-apps" title="Servidor" class="settings-list-item" />
          <v-list-item prepend-icon="mdi-shield-outline" title="Contraseña" class="settings-list-item" />
          
        </v-list>
      </div>

      <!-- Settings content area -->
      <div class="settings-main">
        <!-- Theme setting -->
        <div class="setting-row">
          <div class="setting-label">Theme</div>
          <div class="setting-control">
            <v-select v-model="theme" :items="['Light', 'Dark', 'System']" variant="plain" hide-details
              class="dropdown-select" density="comfortable">
              <template v-slot:append>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-select>
          </div>
        </div>

        <!-- Code display toggle -->
        <div class="setting-row">
          <div class="setting-label">Always show code when using data analyst</div>
          <div class="setting-control">
            <v-switch v-model="showCode" color="success" hide-details inset></v-switch>
          </div>
        </div>

        <!-- Follow-up suggestions toggle -->
        <div class="setting-row">
          <div class="setting-label">Show follow up suggestions in chats</div>
          <div class="setting-control">
            <v-switch v-model="showSuggestions" color="success" hide-details inset></v-switch>
          </div>
        </div>

        <!-- Language setting -->
        <div class="setting-row">
          <div class="setting-label">Language</div>
          <div class="setting-control">
            <v-select v-model="language" :items="['English', 'Spanish', 'French', 'Auto-detect']" variant="plain"
              hide-details class="dropdown-select" density="comfortable">
              <template v-slot:append>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-select>
          </div>
        </div>

        <!-- Archive options -->
        <div class="setting-row">
          <div class="setting-label">Archived chats</div>
          <div class="setting-control">
            <v-btn class="action-button" variant="outlined" rounded>
              Manage
            </v-btn>
          </div>
        </div>

        <!-- Archive all chats option -->
        <div class="setting-row">
          <div class="setting-label">Borar todos los ajustes</div>
          <div class="setting-control">
            <v-btn class="action-button" variant="outlined" rounded>
              Archive all
            </v-btn>
          </div>
        </div>

        <!-- Delete all chats option -->
        <div class="setting-row">
          <div class="setting-label">Reiniciar ajusets</div>
          <div class="setting-control">
            <v-btn color="error" class="action-button" rounded>
              Reinciar </v-btn>
          </div>
        </div>

        <!-- Logout option -->
        <div class="setting-row">
          <div class="setting-label">Log out on this device</div>
          <div class="setting-control">
            <v-btn class="action-button" variant="outlined" rounded>
              Log out
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.settings-container {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.close-button {
  color: #999;
  border-radius: 50%;
  height: 48px;
  width: 48px;
}

.settings-content {
  display: flex;
  flex: 1;
}

.settings-sidebar {
  width: 280px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
}

.settings-list {
  background-color: transparent;
}

.settings-list-item {
  border-radius: 8px;
  margin: 4px 12px;
  height: 48px;
}

.settings-list-item.active {
  background-color: rgba(255, 255, 255, 0.08);
}

.settings-main {
  flex: 1;
  padding: 20px 40px;
}

.setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  min-height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.setting-label {
  font-size: 16px;

}

.setting-control {
  min-width: 140px;
}

.dropdown-select {
  max-width: 280px;
}

.action-button {
  min-width: 140px;
  border-radius: 999px;
}
</style>